function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
/* globals angular */
(function () {
  'use strict';

  angular.module('wsLrs.directives').service('QuickFilters', ['Utils', 'CardRegistry', function (Utils, CardRegistry) {
    function isReportTypeQuickFilter(card, pickerItemType) {
      var type = Utils._try(function () {
        return card.configuration.quickFilters[pickerItemType].type;
      });
      return type === 'report';
    }
    function getQuickFilterItemName(itemName) {
      switch (itemName) {
        case 'people':
        case 'groups':
        case 'group-types':
          return 'people';
        case 'activities':
        case 'activity-types':
          return 'activities';
        case 'verbs':
          return 'verbs';
        case 'dates':
          return 'dates';
        default:
          return "";
      }
    }
    var self = {
      _openFilterSection: null,
      _dashboardFilters: {},
      // Were quick filters purposefully closed by the user?
      _state: null,
      getOpenSection: function getOpenSection() {
        return self._openFilterSection;
      },
      setOpenSection: function setOpenSection(section) {
        self._openFilterSection = section;
      },
      clearOpenSection: function clearOpenSection() {
        self._openFilterSection = null;
      },
      getDashboardFilter: function getDashboardFilter(id) {
        return self._dashboardFilters[id];
      },
      setDashboardFilter: function setDashboardFilter(id, filter) {
        self._dashboardFilters[id] = angular.copy(filter);
      },
      clearDashboardFilter: function clearDashboardFilter(id) {
        delete self._dashboardFilters[id];
      },
      getState: function getState() {
        return this._state;
      },
      setState: function setState(newState) {
        this._state = newState;
      },
      buildShowSection: function buildShowSection(quickFilters) {
        var defaultFilterSections = {
          people: true,
          verbs: true,
          activities: true,
          dates: true
        };
        // Ex: { 'people': { type: 'disabled' }, 'verbs': { type: 'all' }, 'activities': { type: 'custom', ...} }
        // Becomes: { people: false, verbs: true, activities: true }
        return Object.keys(quickFilters).reduce(function (acc, curr) {
          acc[curr] = quickFilters[curr] && quickFilters[curr].type !== 'disabled';
          return acc;
        }, defaultFilterSections);
      },
      hasAnyQuickFiltersEnabled: function hasAnyQuickFiltersEnabled(quickFilters) {
        return Object.keys(quickFilters).reduce(function (acc, curr) {
          return quickFilters[curr].type && quickFilters[curr].type !== 'disabled' ? true : acc;
        }, false);
      },
      getQuickFilterSortParam: function getQuickFilterSortParam(referenceType, referenceId, _ref, defaultParam) {
        var itemName = _ref.itemName;
        if (referenceType === 'report') {
          var card = CardRegistry.get(referenceId);
          var isReportType = isReportTypeQuickFilter(card, getQuickFilterItemName(itemName));
          var searchingForGroupTypes = itemName === 'group-types';
          if (isReportType && !searchingForGroupTypes) {
            return 'dimension[0].label';
          } else if (searchingForGroupTypes) {
            return null;
          }
        }
        return defaultParam;
      }
    };
    return self;
  }]).directive('wsQuickFilters', ['$location', '$route', 'Activities', 'Verbs', 'People', 'Groups', 'GroupUtils', '$http', '$timeout', '$q', 'ExplorerUtils', 'Interactions', 'Utils', 'QuickFilters', 'AppPermissions', 'CardRegistry', 'CardServices', 'Alerts', 'UserRoles', 'User', 'Dashboards', 'Api', function ($location, $route, Activities, Verbs, People, Groups, GroupUtils, $http, $timeout, $q, ExplorerUtils, Interactions, Utils, QuickFilters, AppPermissions, CardRegistry, CardServices, Alerts, UserRoles, User, Dashboards, Api) {
    return {
      templateUrl: "modules/common/directives/filters/filters.html",
      scope: {
        cfg: "=?",
        referenceType: '@',
        referenceId: '<'
      },
      link: function link($scope) {
        $scope.showApplyFiltersLink = UserRoles.isOrgAdmin(User.get());
        $scope.showSection = QuickFilters.buildShowSection($scope.cfg.quickFilters);

        // We're copying the configuration, so we don't modify it
        $scope.customDateQuickFilters = angular.copy(Utils._try(function () {
          return $scope.cfg.quickFilters.dates.customDates || [];
        }, []));
        $scope.showCustomDateQuickFilters = $scope.customDateQuickFilters.length > 0;
        $scope.isGroup = GroupUtils.isGroup;
        var isDashboardView = Utils._try(function () {
          return $scope.$parent.cardGroup;
        }, false); // As opposed to detail-level, report view

        if ($location.search().filter) {
          //read filter from url
          $scope.filter = JSON.parse($location.search().filter);
          $scope.openFilter = QuickFilters.getOpenSection();
          applyCustomDateSelectedStatus($scope.filter, $scope.customDateQuickFilters);
          if (QuickFilters.getState() !== 'closed') {
            // Open filter on load if it's not empty and
            // user didn't manually close the quick filters directive
            $scope.cfg.showFilter = true;
          }

          // Allow ability to collapse quick filters using param
          if ($location.search().collapseQuickFilters) {
            $scope.cfg.showFilter = false;
          }
        } else {
          $scope.filter = {};
          QuickFilters.clearOpenSection();
        }
        $scope.close = function () {
          $scope.cfg.showFilter = false;
          QuickFilters.setState('closed');
        };
        $scope.open = function () {
          $scope.cfg.showFilter = true;
          QuickFilters.setState('open');
        };
        $scope.isDemoMode = function isDemoMode() {
          return $route.current.params && $route.current.params.demo === 'true';
        };
        $scope.openFilterSection = function openFilterSection(section) {
          if ($scope.openFilter === section) {
            $scope.openFilter = null;
          } else {
            $scope.openFilter = section;
          }
          QuickFilters.setOpenSection($scope.openFilter);
        };
        $scope.hasFilter = function hasFilter() {
          return !_.isEmpty($scope.filter);
        };
        $scope.dialog = {
          show: false
        };
        $scope.filterPickerConfig = {
          isDemoMode: $scope.isDemoMode,
          dialogChoice: $scope.dialogChoice,
          referenceType: $scope.referenceType,
          referenceId: $scope.referenceId
        };
        $scope.filterActivityPickerConfig = {
          selectedActivities: [],
          excludedActivities: [],
          immutableSelection: [],
          pickerConfig: $scope.filterPickerConfig,
          isDemoMode: $scope.isDemoMode,
          relatedActivitiesFilterEnabled: true
        };
        $scope.filterPeoplePickerConfig = {
          selectedPeopleOrGroups: [],
          intersectGroups: false,
          excludedPeopleOrGroups: [],
          intersectExcludedGroups: false,
          immutableSelection: [],
          pickerConfig: $scope.filterPickerConfig,
          isDemoMode: $scope.isDemoMode,
          personPicker: {}
        };
        $scope.filterVerbPickerConfig = {
          selectedVerbs: [],
          excludedVerbs: [],
          immutableSelection: [],
          pickerConfig: $scope.filterPickerConfig,
          isDemoMode: $scope.isDemoMode
        };
        function dashboardHasGroupBasedDimension() {
          var isGroupBasedFirstDimension = false;
          Dashboards.forCardsOnCurrentDashboard(function (card) {
            isGroupBasedFirstDimension = reportHasGroupBasedDimension(card.configuration);
            if (isGroupBasedFirstDimension) {
              // Only need to find a single report that has group-based dimension to determine if we'll exclude from output
              return true;
            }
          });
          return isGroupBasedFirstDimension;
        }
        function getDashboardGroupTypes() {
          var groupTypes = [];
          Dashboards.forCardsOnCurrentDashboard(function (card) {
            var reportGroupTypes = getReportGroupTypes(card.configuration);
            groupTypes = [].concat(_toConsumableArray(groupTypes), _toConsumableArray(reportGroupTypes));
          });
          return groupTypes;
        }
        function getReportGroupTypes(reportConfig) {
          return Utils._try(function () {
            return reportConfig.filter.groupTypeNames || [];
          }, []);
        }
        function reportHasGroupBasedDimension(reportConfig) {
          return Utils._try(function () {
            return reportConfig.dimensions[0].statementProperty.indexOf('groups.id') > -1;
          }, false);
        }
        $scope.showOutputFilterSection = function () {
          var cardConfig = angular.copy($scope.cfg.cardConfig);
          var cardWithoutConfig = !$scope.cfg.showFilter || !cardConfig;
          if (!isDashboardView && cardWithoutConfig) {
            return;
          }
          var quickFilterSelectedPeopleOrGroups = $scope.filterPeoplePickerConfig.selectedPeopleOrGroups;
          var selectedQuickFilterGroups = quickFilterSelectedPeopleOrGroups.filter(GroupUtils.isGroup);
          var selectedQuickFilterGroupTypes = quickFilterSelectedPeopleOrGroups.filter(GroupUtils.isGroupType);
          var quickFilterHasGroups = selectedQuickFilterGroups.length > 0;
          var isGroupBasedFirstDimension = isDashboardView ? dashboardHasGroupBasedDimension() : reportHasGroupBasedDimension(cardConfig);
          var groupTypes = isDashboardView ? getDashboardGroupTypes() : getReportGroupTypes(cardConfig);
          var filterOrQuickFilterHasGroupTypes = selectedQuickFilterGroupTypes.concat(groupTypes).length > 0;
          var showOutputFilter = isGroupBasedFirstDimension && quickFilterHasGroups && filterOrQuickFilterHasGroupTypes;
          if (showOutputFilter) {
            processGroupExclusions();
          }
          return showOutputFilter;
        };
        function processGroupExclusions() {
          if (isDashboardView) {
            checkAndExcludeFromOutput({
              groupTypeNames: _toConsumableArray(new Set(Dashboards.getCards().map(function (card) {
                return card.configuration && card.configuration.filter ? card.configuration.filter.groupTypeNames : [];
              }).filter(function (gts) {
                return !!gts;
              }).flat()))
            });
          } else {
            var cardFilter = $scope.cfg.cardConfig.filter;
            checkAndExcludeFromOutput(cardFilter);
          }
        }
        function checkAndExcludeFromOutput(filter) {
          $scope.filterPeoplePickerConfig.selectedPeopleOrGroups.filter(GroupUtils.isGroup).forEach(function (group) {
            var inGroupTypes = Utils._try(function () {
              return filter.groupTypeNames.includes(group.type.name);
            }, false);

            // We're checking to see if a group has been added in the quick filter that is NOT
            // part of the original card configuration. If it's not part of the original config,
            // then it doesn't need to be included in the output.
            var quickFilter = $scope.filter;
            var inGroupIds = Utils._try(function () {
              return quickFilter.groupIds.includes(group.id);
            }, false);

            // we automatically exclude any group whose type is not included in the card config
            // and whose id is not in the quickFilter's groupIds array
            if (!inGroupTypes && !inGroupIds) {
              group.excludeFromOutput = true;
            }
          });
        }
        $scope.excludedGroupsCount = function excludedGroupsCount() {
          return _.chain($scope.filterPeoplePickerConfig.selectedPeopleOrGroups).filter(GroupUtils.isGroup).where({
            excludeFromOutput: true
          }).value().length;
        };
        $scope.toggleExcludeFromOutput = function toggleExcludeFromOutput(group) {
          group.excludeFromOutput = !group.excludeFromOutput;
          handlePeopleOrGroups($scope.filterPeoplePickerConfig.selectedPeopleOrGroups);
        };
        var emptyDateFilter = {
          dateType: 'none',
          trailingAmount: 1,
          trailingType: 'days',
          customDateFrom: null,
          customDateTo: null
        };
        $scope.dateFilter = $scope.filter.dateFilter || angular.copy(emptyDateFilter);
        $scope.filterDatePickerConfig = {
          dateFilter: $scope.dateFilter
        };
        $scope.pickerActions = {
          activityPicker: $scope.filterActivityPickerConfig,
          verbPicker: $scope.filterVerbPickerConfig,
          peoplePicker: $scope.filterPeoplePickerConfig
        };
        $scope.openDialog = function openDialog(type, isCustom) {
          $scope.dialog.show = true;
          $scope.dialogChoice = {
            picker: false,
            toAdvanced: false,
            toSimple: false,
            pickerLoading: false,
            isCustom: isCustom
          };
          $scope.filterPickerConfig.dialogChoice = $scope.dialogChoice;

          // set the dialogChoice option, then resolve dialogChoice.customConfig
          $scope.dialogChoice[type] = true;
          if (type.toLowerCase().indexOf("picker") !== -1) {
            $scope.dialogChoice.picker = true;
            if ($scope.pickerActions[type]) {
              $scope.dialogChoice.pickerLoading = null;
              $timeout(function () {
                if ($scope.dialogChoice.pickerLoading === null) {
                  $scope.dialogChoice.pickerLoading = true;
                }
              }, 1000);
              $scope.pickerActions[type].buildPicker();
            }
          }
        };
        $scope.filterActivityPickerConfig.openDialog = $scope.openDialog;
        $scope.filterPeoplePickerConfig.openDialog = $scope.openDialog;
        $scope.filterVerbPickerConfig.openDialog = $scope.openDialog;
        function unselectAllCustomDates() {
          $scope.customDateQuickFilters.forEach(function (f) {
            f.selected = false;
          });
        }
        $scope.selectCustomDateFilter = function (customDateFilter) {
          var currentlySelected = customDateFilter.selected;
          unselectAllCustomDates();
          customDateFilter.selected = !currentlySelected;
          if (!currentlySelected) {
            // This object defines view settings
            $scope.dateFilter = customDateFilter.dateFilter;

            // This object is used to build the filter view when "Apply quick filters" is clicked
            $scope.filterDatePickerConfig.dateFilter = customDateFilter.dateFilter;
          } else {
            $scope.dateFilter = {
              dateType: 'none'
            };
            $scope.filterDatePickerConfig.dateFilter = {
              dateType: 'none'
            };
          }
        };
        $scope.earliestStatementDate = null;
        Interactions.get({
          size: 1,
          ascending: true
        }).then(function (results) {
          $scope.earliestStatementDate = results.length === 0 ? new Date() : Utils.parseISO8601DateTime(results[0].timestamp);
          return true;
        });

        // Only show 'exclude inactive people' checkbox if the org has inactives
        $scope.filterPeoplePickerConfig.hasInactives = false;
        $http.get(Api.url("/inactive/has-inactives")).then(function (r) {
          $scope.filterPeoplePickerConfig.hasInactives = r.data.hasInactives;
        });
        $timeout(function () {
          ExplorerUtils.populateSimpleModeScope($scope.filter, {
            activityPickerConfig: $scope.filterActivityPickerConfig,
            verbPickerConfig: $scope.filterVerbPickerConfig,
            peoplePickerConfig: $scope.filterPeoplePickerConfig,
            scope: $scope
          });
          $scope.filtersLoaded = true;
        }, 50);
        $scope.updateFilteredView = function () {
          if ($scope.filter.not && _.isEmpty($scope.filter.not)) {
            delete $scope.filter.not;
          }
          if (_.isEmpty($scope.filter)) {
            if (isDashboardView) {
              QuickFilters.clearDashboardFilter($scope.$parent.cardGroup.id);
            }
            $location.search('filter', null);
          } else {
            $location.search('filter', JSON.stringify($scope.filter));
          }
        };
        function handleActivities(item) {
          if (!$scope.filtersLoaded) {
            return;
          }
          var actIds = [];
          var activityTypes = [];
          _.each(item, function (a) {
            if (a.activityId) {
              actIds.push(a.activityId);
            } else {
              activityTypes.push(a.id);
            }
          });
          if (_.isEmpty(actIds)) {
            delete $scope.filter.activityIds;
          } else {
            $scope.filter.activityIds = {
              ids: actIds
            };
          }
          if (_.isEmpty(activityTypes)) {
            delete $scope.filter.activityTypes;
          } else {
            $scope.filter.activityTypes = activityTypes;
          }
        }
        function handleExcludedActivities(item) {
          if (!$scope.filtersLoaded) {
            return;
          }
          var filter = {
            activityIds: {
              ids: []
            },
            activityTypes: []
          };
          _.each(item, function (a) {
            if (a.activityId) {
              filter.activityIds.ids.push(a.activityId);
            } else {
              filter.activityTypes.push(a.id);
            }
          });
          if (_.isEmpty(filter.activityIds.ids)) {
            delete filter.activityIds;
          }
          if (_.isEmpty(filter.activityTypes)) {
            delete filter.activityTypes;
          }
          if (Object.keys(filter).length === 0) {
            return;
          }
          if ($scope.filter.not) {
            if ($scope.filter.not.or) {
              var i = _.findIndex($scope.filter.not.or, function (f) {
                return f.activityIds !== undefined || f.activityTypes !== undefined;
              });
              if (i > -1) {
                $scope.filter.not.or[i] = filter;
              } else {
                $scope.filter.not.or.push(filter);
              }
            } else {
              $scope.filter.not.or = [filter];
            }
          } else {
            $scope.filter.not = {
              or: [filter]
            };
          }
        }
        function handlePeopleOrGroups(item) {
          if (!$scope.filtersLoaded) {
            return;
          }

          // Drop any null items that might have snuck in
          item = _.filter(item, function (item) {
            return !!item;
          });
          var people = _.filter(item, function (item) {
            return item.personas;
          });
          if (_.isEmpty(people)) {
            delete $scope.filter.personIds;
          } else {
            $scope.filter.personIds = _.pluck(people, 'id');
          }
          var groups = _.filter(item, function (item) {
            return item.peopleIds;
          });
          var groupIds = [];
          var groupIdsExcludedFromOutput = [];
          _.each(groups, function (group) {
            if (group.excludeFromOutput) {
              groupIdsExcludedFromOutput.push(group.id);
            }
            groupIds.push(group.id);
          });

          // add/remove groups from filter OR
          if (groupIdsExcludedFromOutput.length > 0) {
            $scope.filter.or = [];
            if ($scope.filter.or.length === 0 || !$scope.filter.or[0].excludeFromOutput) {
              $scope.filter.or.unshift({
                excludeFromOutput: true
              }, {
                excludeFromOutput: false
              });
            }
            $scope.filter.or[0].groupIds = groupIdsExcludedFromOutput;
            $scope.filter.or[1].groupIds = groupIds.filter(function (id) {
              return !groupIdsExcludedFromOutput.includes(id);
            });
          } else if ($scope.filter.or) {
            var firstOrs = $scope.filter.or.slice(0, 2).filter(function (f) {
              return typeof f.excludeFromOutput !== 'boolean' || !Array.isArray(f.groupIds);
            });
            var restOrs = $scope.filter.or.slice(2);
            $scope.filter.or = firstOrs.concat(restOrs);
            if ($scope.filter.or.length === 0) {
              delete $scope.filter.or;
            }
          }
          if (_.isEmpty(groupIds)) {
            delete $scope.filter.groupIds;
          } else {
            $scope.filter.groupIds = groupIds;
          }
          var groupTypes = _.filter(item, function (item) {
            return !item.personas && !item.peopleIds;
          });
          if (_.isEmpty(groupTypes)) {
            delete $scope.filter.groupTypeNames;
          } else {
            $scope.filter.groupTypeNames = _.pluck(groupTypes, 'name');
          }
          if ($scope.filterPeoplePickerConfig.intersectGroups && groups.length > 1) {
            $scope.filter.intersectGroups = true;
          } else {
            delete $scope.filter.intersectGroups;
          }
          if ($scope.filterPeoplePickerConfig.excludeInactivePeople) {
            $scope.filter.excludeInactivePeople = true;
          } else {
            delete $scope.filter.excludeInactivePeople;
          }
        }
        function handleExcludedPeopleOrGroups(item) {
          if (!$scope.filtersLoaded) {
            return;
          }

          // Drop any null items that might have snuck in
          item = item.filter(Boolean);

          // Init the NOT & NOT[OR] filters if they don't exist yet
          $scope.filter.not = $scope.filter.not || {};
          $scope.filter.not.or = $scope.filter.not.or || [];

          // Set personIds on the filter
          var people = item.filter(function (i) {
            return i.personas;
          });
          var personIds = people.map(function (p) {
            return p.id;
          });

          // Set groupIds on the filter
          var groups = item.filter(function (i) {
            return i.peopleIds;
          });
          var groupIds = groups.map(function (g) {
            return g.id;
          });
          var groupTypes = item.filter(function (i) {
            return !i.personas && !i.peopleIds;
          });
          var groupTypeNames = groupTypes.map(function (g) {
            return g.name;
          });
          var filter = {
            personIds: Utils.ifEmptyThenNull(personIds),
            groupIds: Utils.ifEmptyThenNull(groupIds),
            groupTypeNames: Utils.ifEmptyThenNull(groupTypeNames)
          };
          var shouldIntersectGroups = $scope.filterPeoplePickerConfig.intersectExcludedGroups && groups.length > 1;
          if (shouldIntersectGroups) {
            $scope.filter.not.intersectGroups = true;
          }
          if (_.isEmpty(filter.personIds)) {
            delete filter.personIds;
          }
          if (_.isEmpty(filter.groupIds)) {
            delete filter.groupIds;
          }
          if (_.isEmpty(filter.groupTypeNames)) {
            delete filter.groupTypeNames;
          }
          var hasProperties = Object.keys(filter).length !== 0;
          if (hasProperties) {
            // Find the first NOT[OR] filter that has any of the above properties
            var i = _.findIndex($scope.filter.not.or, function (f) {
              var keys = Object.keys(f).join(', ');
              return keys.includes('personIds') || keys.includes('groupIds') || keys.includes('groupTypeNames');
            });

            // If there's already a NOT[OR] filter replace it, otherwise, push it
            if (i > -1) {
              $scope.filter.not.or[i] = filter;
            } else {
              $scope.filter.not.or.push(filter);
            }

            // Clean up any filters that are empty or have all null values
            var orFiltersWithValues = $scope.filter.not.or.filter(function (f) {
              var keys = Object.keys(f);
              // If no keys (i.e. empty object) filter it out
              if (!keys) {
                return false;
              }

              // If all null values, filter it out
              var allNullValues = keys.map(function (k) {
                return f[k];
              }).filter(Boolean).length === 0;
              return !allNullValues;
            });
            $scope.filter.not.or = orFiltersWithValues;
          }
          deleteEmptyNotOrFilters();
        }
        function handleVerbs(item) {
          if (!$scope.filtersLoaded) {
            return;
          }
          var verbIds = _.pluck(item, 'verbId');
          if (_.isEmpty(verbIds)) {
            delete $scope.filter.verbIds;
          } else {
            $scope.filter.verbIds = {
              ids: verbIds
            };
          }
        }
        function handleExcludedVerbs(item) {
          if (!$scope.filtersLoaded) {
            return;
          }
          var filter = {
            verbIds: {
              ids: _.pluck(item, 'verbId')
            }
          };
          if (_.isEmpty(filter.verbIds.ids)) {
            delete filter.verbIds;
          }
          if (Object.keys(filter).length === 0) {
            return;
          }
          if ($scope.filter.not) {
            if ($scope.filter.not.or) {
              var i = _.findIndex($scope.filter.not.or, function (f) {
                return f.verbIds !== undefined;
              });
              if (i > -1) {
                $scope.filter.not.or[i] = filter;
              } else {
                $scope.filter.not.or.push(filter);
              }
            } else {
              $scope.filter.not.or = [filter];
            }
          } else {
            $scope.filter.not = {
              or: [filter]
            };
          }
        }
        function handleDateFilter(item) {
          if (!$scope.filtersLoaded) {
            return;
          }
          var dateFilter = angular.copy(item);

          // When user initially switches to custom date filter, pre-populate it with all statements date range
          if (dateFilter.dateType === 'custom' && dateFilter.customDateFrom === null && dateFilter.customDateTo === null) {
            // Set the from date to one month ago or the earlier statement date whichever is later
            var oneMonthAgo = new Date();
            oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);
            dateFilter.customDateFrom = oneMonthAgo > $scope.earliestStatementDate ? oneMonthAgo : $scope.earliestStatementDate;
            $scope.dateFilter.customDateFrom = dateFilter.customDateFrom;
            $(".custom-date-from").datepicker('setDate', dateFilter.customDateFrom);
            dateFilter.customDateTo = $scope.today;
            $scope.dateFilter.customDateTo = dateFilter.customDateTo;
            $(".custom-date-to").datepicker('setDate', dateFilter.customDateTo);
          }
          if (dateFilter.dateType === 'none') {
            delete $scope.filter.dateFilter;
          } else {
            $scope.filter.dateFilter = dateFilter;
          }
        }

        /**
         * Check for and delete empty or and not filters
         */
        function deleteEmptyNotOrFilters() {
          try {
            if ($scope.filter.not.or.length === 0) {
              delete $scope.filter.not.or;
            }
            if (Object.keys($scope.filter.not).length === 0) {
              delete $scope.filter.not;
            }
          } catch (e) {
            // Do nothing, one of the filters doesn't exist
          }
        }

        /**
         * Check to see if the current quick filter has an active "dateFilter" property which indicates
         * that we should parse our customQuickFilters and set a "selected" property on the one that is
         * selected so the dateFilter list shows a check-mark by the selected date picker-pill.
         *
         * @param filter Object - Active quick filter to be examined for presence of a dateFilter
         * @param customDateQuickFilters Array - List of currently defined customDateQuickFilters
         * @returns {Array} - List of customDateQuickFilters that should be re-applied to scope with new "selected" property
         */
        function applyCustomDateSelectedStatus(filter, customDateQuickFilters) {
          if (!$location.search() || !$location.search().filter) {
            return [];
          }
          var df = filter.dateFilter;
          if (df && customDateQuickFilters.length) {
            // Return list of date filters with correctly "selected" date filters
            $scope.customDateQuickFilters = customDateQuickFilters.map(function (customDateFilter) {
              var matchingType = df.dateType === customDateFilter.dateFilter.dateType;
              if (matchingType) {
                var type = df.dateType;
                if (type === 'custom') {
                  var matchingFrom = df.customDateFrom === customDateFilter.dateFilter.customDateFrom;
                  var matchingTo = df.customDateTo === customDateFilter.dateFilter.customDateTo;
                  var matchingFieldName = df.fieldName === customDateFilter.dateFilter.fieldName;
                  if (matchingFrom && matchingTo && matchingFieldName) {
                    customDateFilter.selected = true;
                  }
                } else if (type === 'trailing') {
                  var matchingTrailAmount = df.trailingAmount === customDateFilter.dateFilter.trailingAmount;
                  var matchingTrailType = df.trailingType === customDateFilter.dateFilter.trailingType;
                  var _matchingFieldName = df.fieldName === customDateFilter.dateFilter.fieldName;
                  if (matchingTrailAmount && matchingTrailType && _matchingFieldName) {
                    customDateFilter.selected = true;
                  }
                }
              }
              return customDateFilter;
            });
          }
        }
        $scope.clearFilters = function clearFilters() {
          QuickFilters.clearOpenSection();
          if (isDashboardView) {
            QuickFilters.clearDashboardFilter($scope.$parent.cardGroup.id);
          }
          $location.search('filter', null);
        };

        /**
         * Apply the currently selected filters to the view whether it be
         * a report detail view, or a dashboard view.
         */
        $scope.applyFilters = function applyFilters() {
          var filters = {
            activities: $scope.filterActivityPickerConfig.selectedActivities,
            excludedActivities: $scope.filterActivityPickerConfig.excludedActivities,
            peopleOrGroups: $scope.filterPeoplePickerConfig.selectedPeopleOrGroups,
            excludedPeopleOrGroups: $scope.filterPeoplePickerConfig.excludedPeopleOrGroups,
            verbs: $scope.filterVerbPickerConfig.selectedVerbs,
            excludedVerbs: $scope.filterVerbPickerConfig.excludedVerbs,
            date: $scope.filterDatePickerConfig.dateFilter
          };
          $scope.filter.includeRelatedActivities = $scope.filterActivityPickerConfig.includeRelatedActivities;
          handleActivities(filters.activities);
          handleExcludedActivities(filters.excludedActivities);
          handlePeopleOrGroups(filters.peopleOrGroups);
          handleExcludedPeopleOrGroups(filters.excludedPeopleOrGroups);
          handleVerbs(filters.verbs);
          handleExcludedVerbs(filters.excludedVerbs);
          handleDateFilter(filters.date);
          $scope.updateFilteredView();
        };
        $scope.filterSize = _.debounce(function () {
          return _.size($scope.filter);
        }, true);
      }
    };
  }]);
})();
